import { EmptyStatePage } from '../../../EmptyStatePage';
import { useCustomTranslation } from '../../../../../hooks';
import { ResetButton } from '../../components';
import { faRotateRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Actions = () => <ResetButton StartIcon={<FontAwesomeIcon icon={faRotateRight} />} variant="outlined" />;

export const KanbanFilterEmptyState = () => {
  const { tWrapper } = useCustomTranslation('components.table.emptyState');

  return <EmptyStatePage Actions={<Actions />} text={tWrapper('title')} />;
};
